export const ping = (event) => {
  const proxySlug = document.querySelector('meta[name=joone-charge-proxy-slug]')
  const proxsySlugName = proxySlug ? proxySlug.content : 'tellida'
  const url = `/apps/${proxsySlugName}/api/ping/?event=${event}`
  fetch(url)
}
